import React from 'react';
import cx from 'classnames';

type Coverage = {
    /**
     * Coverage unique identifier
     */
    id: string;
    /**
     * Coverage label
     */
    name: React.ReactNode;
    /**
     * Coverage label variant
     */
    variant?: 'label' | 'covered' | 'not-covered';
    /**
     * If Coverage is a gift
     */
    gift?: boolean;
    /**
     * Coverage label more info
     */
    info?: React.ReactNode;
    /**
     * Coverage label icon shape
     */
    shape?: string;
};

// eslint-disable-next-line @typescript-eslint/ban-types
type CoverageLabelProps = Omit<Coverage, 'id'>;

const CoverageLabel = ({ name, variant = 'label', gift, info, shape, ...props }: CoverageLabelProps) => {
    let content: React.ReactNode;

    if (variant === 'label') {
        content = (
            <>
                <h6>{name}</h6>
                <p className="small u-spacing-stack-none">{info}</p>
            </>
        );
    } else if (variant === 'covered') {
        content = (
            <>
                <div className="flos-package-label-mobile">
                    <h6 className="u-spacing-stack-xs">{name}</h6>
                    <p className="small u-spacing-stack-none">{info}</p>
                </div>
                <flos-icon class={`${shape ? 'is-indigo' : 'is-green has-fill'}`} shape={shape ? shape : 'circle-check-animated'} size={32} />
            </>
        );
    } else {
        content = (
            <>
                <div className="flos-package-label-mobile">
                    <h6 className="u-spacing-stack-xs">{name}</h6>
                    <p className="small u-spacing-stack-none">{info}</p>
                </div>
                <flos-icon class={'has-fill is-supplement-grey-medium '} shape={'circle-close'} size={32} />
            </>
        );
    }

    return (
        <li className={cx('flos-package-label', gift ? 'flos-package-label-gift' : '')} {...props}>
            {content}
        </li>
    );
};

export type { Coverage };
export { CoverageLabel };
export default CoverageLabel;
